<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col md="12">
				<b-card>
					<b-row slot="header" class="justify-content-between">
						<b-col md="6">
							<strong>Sucursales</strong>
						</b-col>
						<b-col md="6" class="text-right">
							<b-spinner v-if="loading" variant="primary" label="Spinning" small></b-spinner>
						</b-col>
					</b-row>

					<b-card-body class="table-responsive">
						<b-row class="justify-content-between">
							<b-col md="6">

							</b-col>
							<b-col md="4">
								<b-form-group>
									<label class="m-0"><strong class="text-black-50">Buscar:</strong></label>
									<b-input v-model="filter" type="search"></b-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-table :items="accountsList"
								 :current-page="currentPage"
								 :per-page="perPage"
								 :fields="accountsTableFields"
								 head-variant="light"
								 :sort-by.sync="sortBy"
								 :sort-desc.sync="sortDesc"
								 :filter="filter"
								 :filter-included-fields="filterOn"
								 :busy="loading"
								 show-empty
								 striped
								 empty-filtered-text="No hay resultados disponibles"
								 empty-text="No hay sucursales disponibles"
								 sort-icon-left
								 @filtered="onFiltered">
							<template v-slot:table-busy>
								<div class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
								</div>
							</template>

							<div slot="detail" slot-scope="item">
								<!--<button class="btn btn-info text-white" @click="loginAccount(item.item.accountID)">
									<i class="icon-eyeglass"></i>
								</button>-->
								<router-link :to="{name: 'AccountDetail', params: {id: item.item.accountID}}">Ver
								</router-link>
							</div>
						</b-table>
						<nav class="d-flex justify-content-center" v-if="totalRows > perPage">
							<b-pagination
								:total-rows="totalRows"
								:per-page="perPage"
								v-model="currentPage"
								prev-text="<<"
								next-text=">>"
								hide-goto-end-buttons/>
						</nav>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import {Callout} from '@coreui/vue'

	export default {
		name: 'dashboard',
		mounted() {
			if (this.$store.state.accounts.length <= 0) {
				this.loading = true;
				this.$store.dispatch('getAccounts')
					.then((accounts) => {
						this.accountsList = this.$store.state.accounts;
						this.totalRows = this.accountsList.length;
					})
					.catch((err) => {
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					})
			} else {
				this.accountsList = this.$store.state.accounts;
				this.totalRows = this.accountsList.length;
			}
		},
		components: {
			Callout,
		},
		data: function () {
			return {
				perPage: 10,
				currentPage: 1,
				totalRows: 1,
				accountsTableFields: {
					accountNumber: {
						label: 'Número de Cuenta',
						sortable: true,
					},
					alias: {
						label: 'Alias',
						sortable: true,
					},
					detail: {
						label: 'Detalle',
						class: 'text-center'
					}
				},
				accountsList: [],
				loading: false,
				sortBy: 'accountNumber',
				sortDesc: false,
				filter: '',
				filterOn: []
			}
		},
		methods: {
			onFiltered(filteredItems) {
				this.totalRows = filteredItems.length;
				this.currentPage = 1
			}
		}
	}
</script>

<style>
	/* IE fix */
	#card-chart-01, #card-chart-02 {
		width: 100% !important;
	}
</style>
